import Ready from 'utils/ready';
import loadScript from 'utils/load-script';

Ready(() => {
  const init = async () => {
    await loadScript('//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js');
  };

  const observation = () => {
    const main = document.querySelector('main');
    const widgets: NodeListOf<HTMLElement> = main.querySelectorAll('.trustpilot-widget');

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          init();
          observer.disconnect();
        }
      });
    });

    widgets.forEach((widget) => {
      observer.observe(widget);
    });
  };

  observation();

  document.addEventListener('filters:loaded', () => {
    observation();
  });
});
